import React from 'react'
import { messageBoxShowAction } from 'src/reducers/message-box/action'
import { componentBoxShowAction } from 'src/reducers/component-box/action'
import { teamsMemberExportAction } from 'src/reducers/teams/action'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import ComponentBoxContent from 'src/model/component-box'
import CollectionSelectionModal from 'src/components/collection-select-modal'
import {
  AddMember,
  DeleteMember,
  EditMember,
  ImportMembers,
} from 'src/pages/collection/components/collection-page-view/components/learners/components/teams-member-list/components'
import { MagicViewContent } from 'src/pages/collection/components/collection-page-view/components/learners/components/teams-member-list/components/email-settings'

const titleHtml = (text, icon) => `
  <div style="display: flex; align-items: center">
    ${icon ? `<img style="margin-right: 10px" src="${icon}" alt="" />` : ''}
    <span style="font-size: 18px; font-weight: 700; color: #002E47">${text}</span>
  </div>`

/** The learner dialogs the old learners list opened, as plain functions. */
export const learnerActions = dispatch => ({
  add: refresh =>
    dispatch(
      componentBoxShowAction(
        new ComponentBoxContent(
          <AddMember dispatch={dispatch} refresh={refresh} />,
          { hideCloseButton: false },
        ),
      ),
    ),

  import: () =>
    dispatch(
      componentBoxShowAction(
        new ComponentBoxContent(<ImportMembers dispatch={dispatch} />, {
          hideCloseButton: false,
        }),
      ),
    ),

  export: teamsId => dispatch(teamsMemberExportAction(teamsId, null)),

  linkFromPath: pathId =>
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: 'Link from learning path',
          description:
            'Dynamically import learners from another learning path, and any updates to its learner list will be reflected. Just select the learning path to import from.',
          draggable: false,
          component: <CollectionSelectionModal id={pathId} />,
          maxWidth: '720px',
        }),
      ),
    ),

  inviteByEmail: () =>
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          component: <MagicViewContent />,
          title: titleHtml('Send email'),
        }),
      ),
    ),

  edit: entity =>
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: titleHtml('Edit Learner'),
          component: <EditMember entity={entity} dispatch={dispatch} />,
          maxWidth: '720px',
        }),
      ),
    ),

  remove: entity =>
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: titleHtml('Delete Learner', '/assets/delete-icon.svg'),
          component: <DeleteMember entity={entity} dispatch={dispatch} />,
          maxWidth: '720px',
        }),
      ),
    ),
})
